import React from 'react';
import { Button } from '@fashionnovateam/nova-ui-toolkit';
import { useJoinPoChat } from '../../../Lib/Hooks/purchase-orders.hooks';

export function JoinChat(props: { userId: string; purchaseOrderId: string }) {
  const { userId, purchaseOrderId } = props;

  const joinChatProcess = useJoinPoChat();

  return (
    <div className="flex-none p-4 border-t border-neutral-300 w-full max-w-[620px]">
      <Button
        loading={joinChatProcess.isLoading}
        onClick={() => joinChatProcess.mutate({ userId, purchaseOrderId })}
      >
        Join Chat
      </Button>
    </div>
  );
}
